import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../lib/data";
import useReveal from "../../hooks/use-reveal";

export const Faq = () => {
  useReveal();
  return (
    <section id="faq" className="py-20 sm:py-28 px-6 sm:px-10 lg:px-14 bg-bone-2">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 reveal">
          <p className="eyebrow mb-3">Got Questions?</p>
          <h2 className="font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-tight">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="reveal space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="bg-paper border border-line rounded-2xl px-6 data-[state=open]:border-forest"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-sans font-semibold text-base sm:text-lg text-ink py-5 hover:no-underline text-left"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-ink-soft leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
